import { Fragment, useEffect } from 'react';

export const ReloadRedirect: React.FC<unknown> = () => {
  useEffect(() => {
    window.location.reload();
  }, []);

  return <Fragment />;
};
